import { IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { connect } from 'react-redux';
import { IState } from '../../../store';
import * as Formatters from '../../../utils/bargain_terms_formatter';
import { FOfferType, getOfferType } from '../../../utils/offer_type';
import { BargainTermsBlock, IBargainTermsBlockProps } from './bargain_terms_group';
import { trackOpenPhones } from './tracking';

function mapRentTerms(offer: IOfferSchema, withAdditions?: boolean): [string, string | string[]][] {
  const {
    bargainTerms,
    building,
    vatPriceTotalPerMonthRur,
    minVatPriceTotalPerMonthRur,
    pricesPerSquareMeterPerYear,
  } = offer;

  const {
    vatType,
    leaseTermType,
    hasGracePeriod,
    includedOptions,
    prepayMonths,
    agentBonus,
    clientFee,
    securityDepositPrices,
    agentFee,
    minLeaseTerm,
  } = bargainTerms;

  const minVat = minVatPriceTotalPerMonthRur;
  const vat = vatPriceTotalPerMonthRur;
  const pricesPerSquareMeterPerYearRur = pricesPerSquareMeterPerYear ? pricesPerSquareMeterPerYear.rur : null;

  let terms: [string, string | string[]][] = [
    ['Цена', Formatters.priceFormatter(offer) || '-'],
    ['Ставка', Formatters.AreaPerMetterFormatter(pricesPerSquareMeterPerYearRur)],
    ['Налог', Formatters.vatTypeFormatter(vatType, vat, minVat)],
    ['Обеспечительный платеж', Formatters.securityDeposites(securityDepositPrices)],
    ['Коммунальные платежи', Formatters.utilityCharges(includedOptions)],
    ['Эксплуатационные расходы', Formatters.operationalCosts(includedOptions)],
    ['Предоплата', Formatters.prepayMonths(prepayMonths)],
    ['Тип аренды', Formatters.leaseTypeFormatter(bargainTerms.leaseType)],
    ['Срок аренды', Formatters.leaseTermTypeFormatter(leaseTermType)],
    ['Минимальный срок аренды', minLeaseTerm ? `${minLeaseTerm} мес.` : '-'],
    ['Арендные каникулы', Formatters.hasGracePeriodFormatter(hasGracePeriod)],
    ['Стоимость парковки', Formatters.parkingFormatter(building ? building.parking : null)],
    ['Комиссия от клиента', Formatters.clientFee(clientFee)],
  ];

  const addTerms: [string, string | string[]][] = [
    ['Комиссия от агента', Formatters.agentFee(agentFee)],
    ['Бонус агенту', Formatters.agentBonus(agentBonus)],
  ];

  if (getOfferType(offer) === FOfferType.Garage) {
    terms = terms.filter(([name]) => name !== 'Налог');
  }

  return withAdditions ? terms.concat(addTerms) : terms;
}

function mapSaleTerms(offer: IOfferSchema, withAdditions?: boolean) {
  const { bargainTerms, vatPriceTotalRur, minVatPriceTotalRur, pricesPerSquareMeter } = offer;

  const { vatType, agentBonus, contractType } = bargainTerms;

  const pricesPerSquareMeterRur = pricesPerSquareMeter ? pricesPerSquareMeter.rur : null;

  let terms: [string, string | string[]][] = [
    ['Цена', Formatters.priceFormatter(offer) || '-'],
    ['Ставка', Formatters.AreaPerUnitFormatter(pricesPerSquareMeterRur)],
    ['Налог', Formatters.vatTypeFormatter(vatType, vatPriceTotalRur, minVatPriceTotalRur)],
    ['Тип сделки', Formatters.formatPPA(contractType)],
  ];

  if (getOfferType(offer) === FOfferType.Garage) {
    terms = terms.filter(([name]) => name !== 'Налог');
  }

  const addTerms: [string, string | string[]][] = [['Бонус агенту', Formatters.agentBonus(agentBonus)]];

  return withAdditions ? terms.concat(addTerms) : terms;
}

function mapStateToProps(state: IState): IBargainTermsBlockProps {
  const isAuthorised = state.offerData.user && state.offerData.user.isAuthenticated && state.offerData.user.isAgent;
  const kpId = state.offerData.kp && state.offerData.kp.id;

  const isRent = state.offerData.offer.dealType === 'rent';

  return {
    phones: state.offerData.offer.phones || [],
    sendCa: (isBot?: boolean) => trackOpenPhones(state.offerData.offer, state.offerData.agent, kpId, isBot),
    terms: isRent
      ? mapRentTerms(state.offerData.offer, !!isAuthorised)
      : mapSaleTerms(state.offerData.offer, !!isAuthorised),
    knAuctionCompanies: state.knAuctionCompanies,
    publishedUserId: state.offerData.offer.publishedUserId,
  };
}

export const BargainTermsBlockContainer = connect<IBargainTermsBlockProps>(mapStateToProps)(BargainTermsBlock);
